import { contactInfo } from "@/mocks/home";

export default function WhatsAppButton() {
  return (
    <a
      href={contactInfo.whatsapp}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="fixed bottom-6 right-4 md:right-6 z-50 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-3 rounded-full shadow-lg transition-all hover:scale-105 cursor-pointer"
      aria-label="Cotízalo por WhatsApp"
    >
      <span className="w-5 h-5 flex items-center justify-center">
        <i className="ri-whatsapp-line text-lg" />
      </span>
      <span className="text-sm font-medium whitespace-nowrap">
        Cotízalo por WhatsApp
      </span>
    </a>
  );
}